import { axiosPut } from 'shared/api/axios'
import { apiUrls } from 'consts'
import { AxiosError } from 'axios'
import displayError from 'shared/utils/displayError'

interface addRecipientProps {
  id: string
  setButtonClickCount: Function
  unCheckFilterDefault: Function
  setDragEndEvent: Function
}

const setDefaultFilterValue = async (props: addRecipientProps) => {

  props.setDragEndEvent(null)
  const catchFunc = (err: AxiosError) => {
    const message: string = err.response!.data?.message ?? 'An error has occurred.'
    displayError({
      errorMessage: message,
      setShowOverlay: () => {},
    })
  }

  const response = await axiosPut(apiUrls.filterValues + '/' + props.id + '/' + apiUrls.actionSetAsDefault, {}, catchFunc)
  if(response.status === 200 || response.status === 201){
    props.setButtonClickCount((prev) => prev + 1)
    props.unCheckFilterDefault()
  }

  return true
}

export default setDefaultFilterValue
